import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DistributorService } from '../../../../services/distributor.service';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { StihlDistributorDTO, StihlDistributorDataDTO } from 'src/app/models/stihl-distributor-dto';
import { visibleContentAnimation } from 'src/app/animations';

@Component({
  selector: 'distributor-detail',
  templateUrl: './distributor-detail.component.html',
  animations: [visibleContentAnimation]
})

export class CommonDistributorDetailComponent implements OnInit {

  @Input() model: StihlDistributorDTO;
  @Input() canSave = true;
  dataform: FormGroup;
  modelData: StihlDistributorDataDTO = new StihlDistributorDataDTO();
  isEdit = false;
  submitted = 0;

  constructor(private distributorService: DistributorService, private toastr: ToastrService) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.model.IdDistributor) {

      this.distributorService.getDistributorData(this.model.IdDistributor).subscribe(resp => {

        if (resp != null) {

          this.isEdit = true;
          this.modelData = resp;
          this.dataform.patchValue(this.modelData);

        }

      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro'
        });
      });

    }

  }

  ngOnInit() {

    this.dataform = new FormGroup({
      IdDistributorData: new FormControl(null),
      IdDistributor: new FormControl(0),
      BillingContact: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Slogan: new FormControl(null, [Validators.required, Validators.maxLength(1500)]),
      FacebookProfile: new FormControl(null, [Validators.maxLength(500)]),
      InstaProfile: new FormControl(null, Validators.maxLength(500)),
      TwitterProfile: new FormControl(null, [Validators.maxLength(500)]),
      LinkedinProfile: new FormControl(null, [Validators.maxLength(500)]),
      YoutubeProfile: new FormControl(null, [Validators.maxLength(500)]),
      BankingEntity: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      AccountHolder: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      Iban: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      BicSwift: new FormControl(null, [Validators.required, Validators.maxLength(500)])
    });

  }

  saveEvent() {

    this.submitted = 1;

    if (this.dataform.invalid) return;

    this.modelData = this.dataform.value;

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…'
    });
    Swal.showLoading();

    if (!this.isEdit)
      this.postData();
    else
      this.putData();

  }

  postData() {

    this.distributorService.postDistributorData(this.modelData).subscribe(resp => {

      this.toastr.success("O registo foi criado com sucesso");
      this.dataform.controls['IdDistributor'].setValue(resp.idDistrib);
      this.dataform.controls['IdDistributorData'].setValue(resp.idDistribData);
      this.isEdit = true;

      Swal.close();
    }, (err) => {

      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar',
        text: 'Ocorreu um erro'
      });
    });
  }

  putData() {

    this.distributorService.putDistributorData(this.modelData.IdDistributorData, this.modelData).subscribe(resp => {

      this.toastr.success("Os dados foram atualizados com sucesso");

      Swal.close();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao atualizar',
        text: 'Ocorreu um erro'
      });
    });
  }
}
